import { isArray } from 'util';
import { RefrigerationGroup } from '../refrigeration-group';

export class RefrigerationGroupBuilder {
  static fromJson(json) {
    return (json)
      ? new RefrigerationGroup(
        json.hash,
        json.name,
        json.refrigerations
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(RefrigerationGroupBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/refrigeration-group.builder.ts